import type { ComponentProps, ReactNode } from "react";
import { CopyIcon } from "@phosphor-icons/react/Copy";
import { Button } from "../Controls/Button";
import { copyToClipboard } from "../Feedback/copyToClipboard";

type CopyToClipboardButtonProps = Omit<
  ComponentProps<typeof Button>,
  "onClick" | "children"
> & {
  /** The string to copy to the clipboard */
  data: string;
  /** Label shown in the success toast (e.g. "Shipment ID") */
  label: string;
  /** Button text. Defaults to "Copy {label}" */
  children?: ReactNode;
};

export function CopyToClipboardButton({
  data,
  label,
  icon,
  children,
  ...rest
}: CopyToClipboardButtonProps) {
  return (
    <Button
      icon={icon ?? CopyIcon}
      onClick={() => copyToClipboard(data, label)}
      // exactOptionalPropertyTypes can't verify the disabled/disabledMessage
      // union through a spread — the caller's type already enforces it.
      {...(rest as object)}
    >
      {children ?? `Copy ${label}`}
    </Button>
  );
}
